/**
 * Copyright © Veeam Software Group GmbH.
 */

import { ProtectedVmVirtualPlatformType } from '@veeam-vspc/models/web-controllers';

export type ProtectedVmPlatformTypes = ProtectedVmVirtualPlatformType;
export const ProtectedVmPlatformTypes = ProtectedVmVirtualPlatformType;
